import React from 'react';
import { CTAButton } from './CTAButton';
import { Timer } from './Timer';
export const DeadlineSection = () => {
  return <section className="w-full bg-red-600 text-white py-16 px-4 md:px-8 lg:px-16" data-id="element-49">
      <div className="max-w-6xl mx-auto" data-id="element-50">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-51">
          <div className="md:w-1/2 order-2 md:order-1" data-id="element-52">
            <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-53">
              Nie czekaj, aż będzie za późno
            </h2>
            <p className="text-xl mb-6" data-id="element-54">
              Każdy dzień zwlekania to kolejny dzień życia w Błędnym Kole
              Odrzucenia. Każdy dzień to szansa na zmianę, która może uratować
              Twoje małżeństwo.
            </p>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg mb-8" data-id="element-55">
              <p className="font-bold mb-2" data-id="element-56">Oferta specjalna kończy się za:</p>
              <Timer data-id="element-57" />
            </div>
            <div className="space-y-4" data-id="element-58">
              <CTAButton text="Chcę przerwać Błędne Koło" data-id="element-59" />
              <CTAButton text="Pobieram e-book za 29,99 zł" variant="white" data-id="element-60" />
            </div>
          </div>
          <div className="md:w-1/2 order-1 md:order-2" data-id="element-61">
            <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rAX9WXybt9Ww50IkzJtrT4junO3AEg28GRSVhL" alt="Pewna siebie kobieta gotowa do działania" className="w-full h-auto rounded-lg shadow-lg" data-id="element-62" />
          </div>
        </div>
      </div>
    </section>;
};